module.exports = __webpack_public_path__ + "public/images/about-12.d2c6609fcdbec5666a86db38d71d7fff.png";